export class Friends {
    constructor() {
        this.service = 'friends';
        this.form = document.querySelector('#form-friends');
        this.submitButton = document.querySelector('#sendInvite');
        this.mandanten = document.querySelectorAll('.mandant');
        this.mandant = document.querySelector('#friends-mandant');

        this.initService();
    };

    initService() {
        this.submitButton.addEventListener('click', event => {
            event.preventDefault();
            this.submit();
        });

        if (this.mandanten) {
            this.mandanten.forEach(element => {
                element.addEventListener('click', event => {
                    event.preventDefault();
                    OVS.app.helper.removeClass('.mandant', 'selected');
                    event.currentTarget.classList.add('selected');
                    this.mandant.value = event.currentTarget.alt;
                });
            });
        }
    };
    
    submit() {
        this.clearErrors();
        let request = new Request('POST', this.form.getAttribute('action'));
        request.formData = this.form;
        request.call((response) => {
            if(response.status == 'ok') {
                this.success();
            } else {
                this.error(response.error);
            }
        });
    };

    success() {
        OVS.app.helper.addClass('#form-holder', 'd-none');
        OVS.app.helper.removeClass('#form-success', 'd-none');
    }

    error(errors) {
        errors.forEach(error => {
            console.log(error);
            let errorMessage = error.element ? error.element : error;
            let element = document.querySelector('.field-' + this.service + '-' + errorMessage + ' > div.text-danger');
            if(element) element.innerHTML = error.message;
        });
    }

    clearErrors() {
        let elements = document.querySelectorAll('.form-group > div.text-danger');
        if(elements) {
            elements.forEach(node => {
                node.innerHTML = '';
            });
        }
    };
};
